import { createStore } from 'redux';
import rootReducer from '../reducers';

export function configureStore(initialState) {
	return createStore(
		rootReducer,
		initialState
	);
}


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/store/configureStore.js